import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import pdf from "../../Assets/Resume/Waqas-Nasir.pdf";
import { AiOutlineDownload } from "react-icons/ai";

function Resume() {

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="Web Developer at Deentek Solutions"
              date="August 2019 — Present"
              content={[
                "Planned, developed, tested, deployed, and maintained web applications.",
                "Provided effective troubleshooting and remediation for web applications.",
                "Worked well independently and within a team setting.",
                "Effectively translated client requirements into application designs and systems requirements.",
                "Followed policies and procedures are related to application methods and quality standards at all times."
              ]}
            />
            <h3 className="resume-title">Internships</h3>
            <Resumecontent
              title="Web Developer Internee at Pak Ever Zone"
              date="April 2019 — July 2019"
              content={[
                "Worked as a productive and positive team member to design, code, test, report, and debug operations.",
                "Successfully identified, diagnosed, and fixed website problems, including broken links, typographical errors, and formatting issues.",
                "Helped to achieve a consistent look and visual theme across the website by promoting uniform fonts, formatting, images, and layout."
              ]}
            />
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="BS Enterprise Resource Planning, PAF KIET"
              date="August 2016 — December 2020"
            />
            <Resumecontent
              title="FSC, Pakistan Shipowners College"
              date="July 2013 — July 2015"
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <AiOutlineDownload />&nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
